var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68338 7.45583C1.77978 5.97175 2.97296 4.80867 4.45835 4.73508C6.60929 4.62852 9.6836 4.5 12 4.5C14.3164 4.5 17.3907 4.62852 19.5417 4.73508C21.027 4.80867 22.2202 5.97175 22.3166 7.45583C22.409 8.8777 22.5 10.6272 22.5 12C22.5 13.3728 22.409 15.1223 22.3166 16.5442C22.2202 18.0283 21.027 19.1913 19.5417 19.2649C17.3907 19.3715 14.3164 19.5 12 19.5C9.6836 19.5 6.60929 19.3715 4.45835 19.2649C2.97296 19.1913 1.77978 18.0283 1.68338 16.5442C1.59102 15.1223 1.5 13.3728 1.5 12C1.5 10.6272 1.59102 8.87769 1.68338 7.45583Z",
    fill: "#FC0D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9V15L15.75 12L9.75 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.157e497a.svg";
export { ForwardRef as ReactComponent };